import React, { ReactNode } from 'react';
import { Heading } from '@razorpay/blade/components';
import styles from '../index.module.scss';

type RunPayrollModalHeaderProps = {
  children: ReactNode;
};

export const RunPayrollModalHeader = ({ children }: RunPayrollModalHeaderProps) => (
  <div className={styles['run-payroll-modal-header']}>
    <Heading as="h2" size="medium" weight="semibold" color="surface.text.gray.normal">
      {children}
    </Heading>
  </div>
);
